<template>
  <div class="w-100">
    <grid-component
      isResizable
      isReorderable
      :canEdit="checkClaim(CAN_EDIT_RMAS)"
      :canDelete="checkClaim(CAN_DELETE_RMAS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="fields"
      :onEdit="onEdit"
      :onDelete="onDelete"
      :handleRowClick="onRowClick"
      :styleCustom="'height: 160px'"
    />
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import { GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';

  export default {
    components: {
      GridSettings,
      GridComponent
    },
    props: {
      rmaLineId: {
        type:  [Number, String],
        default: 0,
      },
      partId: {
        type:  [Number, String],
        default: 0,
      },
    },
    data: () => ({
      selectedRowItemId: 0,
      gridId: GRID_ID.CUSTOMER_RMA_LINES,
      fields: gridFields,
      checkedRowItemIds: [],
      unHideRMAActions: [
        'rtnCheckbox', 'rplCheckbox', 'crLabel'
      ]
    }),
    computed: {
      ...mapGetters('account', ['gridSettingsById']),
      ...mapState('customerRmasLines', ['customerRMALines']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        if (this.customerRMALines == undefined || !this.customerRMALines.length) return [];
        return this.customerRMALines.map((customerRMALine) => ({ ...customerRMALine, selected: customerRMALine.id === this.selectedRowItemId }));
      },
    },
    methods: {
      ...mapActions('customerRmasLines', ['getCustomerRMALines','getCustomerRMALinesByPart']),
      ...mapMutations('customerRmasLines',['setItem']),
      ...mapActions('account', ['saveGridSettings']),
      onRowClick(row) {
        //this.selectedRowItemId = row.dataItem.id;
      },
      onEdit(data) {
        //this.$emit('showEdit', data);
      },
      onDelete(data) {
        //this.$emit('showDelete', data);
      },
    },
    watch: {
      rmaLineId() {
        this.setItem({ resource: 'customerRMALines', payload: [] });
        if(this.rmaLineId) {
          this.getCustomerRMALines(this.rmaLineId);
        }
      },
      partId() {
        this.setItem({ resource: 'customerRMALines', payload: [] });
        if(this.partId) {
          this.getCustomerRMALinesByPart(this.partId);
        }
      },
      customerRMALines() {
        if(this.customerRMALines.length > 0 && this.selectedRowItemId === 0){
          this.selectedRowItemId = this.customerRMALines[0].id;
        }
      },
      selectedRowItemId(newVal) {
        const selectedRow = this.customerRMALines.find(customerRMALines => customerRMALines.id === newVal);
        //this.$emit('selectedCustomerRMALine', selectedRow);
      },
    },
    mounted() {
      this.setItem({ resource: 'customerRMALines', payload: [] });
      if(this.partId) {
        this.getCustomerRMALinesByPart(this.partId);
      }
      if(this.rmaLineId){
        this.getCustomerRMALines(this.rmaLineId);
      }
    },
  };
</script>